type ClubPurchaseInfoProps = {
  price: {
    amount: number;
    currency: string;
  };
  hasDemo: boolean;
};

function formatCurrency(amount: number, currency: string) {
  if (currency.toUpperCase() === 'RUB') {
    return `${amount} ₽`;
  }

  return `${amount} ${currency}`;
}

function BenefitRow({ children }: { children: string }) {
  return (
    <div className="flex gap-2 text-[14px] text-[rgba(26,26,26,0.68)]">
      <span className="text-[var(--accent)]">•</span>
      <span>{children}</span>
    </div>
  );
}

export function ClubPurchaseInfo({ price, hasDemo }: ClubPurchaseInfoProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-baseline gap-2 pb-1">
        <span className="text-[30px] font-black text-[var(--foreground)]">
          {formatCurrency(price.amount, price.currency)}
        </span>
      </div>
      <BenefitRow>Полный доступ ко всем главам клуба</BenefitRow>
      <BenefitRow>Доступ откроется после подтверждённой оплаты</BenefitRow>
      <BenefitRow>Прогресс чтения сохранится в аккаунте</BenefitRow>
      {hasDemo ? <BenefitRow>Есть бесплатные демо-главы</BenefitRow> : null}
    </div>
  );
}
